module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/NewestFeature/latestFeature-fb9412d92220623c95ac333c0ffcbe54.jpg";